var cancelIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21\" height=\"20\" viewBox=\"0 0 21 20\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#B4975A\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\">\n        <path d=\"M19.408 1.007L1.542 18.873M1.542 1.007l17.866 17.866L1.542 1.007z\"/>\n    </g>\n</svg>";

export { cancelIcon as default };
